// WhatsApp helper utilities
export const WA_NUMBER = "971552239345"; // +971 55 223 9345
export const WA_DISPLAY = "+971 55 223 9345";

export function buildWhatsAppLink(message) {
    const text = encodeURIComponent(
        message || "Hi! I'd like to know more about 45DaySpaces interiors and fit-out services in Dubai.",
    );
    return `https://wa.me/${WA_NUMBER}?text=${text}`;
}

/**
 * Detect mobile / touch devices. Mobile browsers block popups from async
 * event handlers, so we must use same-window navigation (which is always
 * allowed) so the WhatsApp app deep-link fires correctly.
 */
export function isMobileDevice() {
    if (typeof window === "undefined" || typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    // Common mobile UA tokens + touch-only devices (iPadOS reports as Mac)
    const mobileUA = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile|Windows Phone/i.test(ua);
    const iPadOS = /Macintosh/.test(ua) && "ontouchend" in document;
    return mobileUA || iPadOS;
}

/**
 * Open WhatsApp. On mobile we use same-window navigation (`location.href`) so
 * the OS deep-link intercepts and the WhatsApp app opens. On desktop we open
 * wa.me in a new tab so the user keeps our site open.
 *
 * IMPORTANT: call this inside the SAME synchronous tick as the user's click
 * (before any `await`) whenever possible — some mobile browsers strip the
 * user-gesture context after async work, which then blocks even `window.open`.
 */
export function openWhatsApp(message) {
    const url = buildWhatsAppLink(message);

    if (isMobileDevice()) {
        // Same-window navigation: never blocked by popup rules. iOS/Android
        // intercept `wa.me/...` and hand off to the installed WhatsApp app.
        window.location.href = url;
        return;
    }

    // Desktop: try new-tab, fall back to same-window if the popup is blocked.
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (!w || w.closed || typeof w.closed === "undefined") {
        window.location.href = url;
    }
}
